import React, { useCallback, useMemo } from 'react';
import { Box, Typography, Paper } from '@mui/material';

import { MealDetailWithTitle } from '../types';
import { getNutritionEmoji } from '../helpers';

import './MealSummary.scss';
import { MetricMealSummary } from '@demind-inc/core';
import { ConvertedMealMacro, convertMealMacro } from '../../../helpers';

interface MealSummaryProps {
  meal?: MealDetailWithTitle;
  mealSummary?: MetricMealSummary;
  style?: React.CSSProperties;
}

const MealSummary: React.FC<MealSummaryProps> = ({ meal, mealSummary, style }) => {
  // Filter valid macros (not null and over 0) and extract units

  // Filter valid macros (not null and over 0) and extract units
  const validMacros = useMemo(
    () => (meal?.macros ? convertMealMacro(meal.macros as any) : {}),
    [meal?.macros]
  );
  const hasValidMacros = !!Object.keys(validMacros).length;

  const validSummaryMacro = useMemo(
    () => (mealSummary?.macros ? convertMealMacro(mealSummary?.macros) : {}),
    [mealSummary?.macros]
  );
  const hasValidSummaryMacro = !!Object.keys(validSummaryMacro).length;

  const renderMacroMetrics = useCallback((targetMacros: ConvertedMealMacro) => {
    return (
      <Box className="meal-summary__macros-container">
        {Object.entries(targetMacros).map(([macro, { value, unit }]) => (
          <div key={macro} className="meal-summary__macro-card">
            <Typography className="meal-summary__macro-label" variant="subtitle2">
              {macro.charAt(0).toUpperCase() + macro.slice(1)}
            </Typography>
            <Typography className="meal-summary__macro-value" variant="body2">
              {getNutritionEmoji(macro)}
              {value}
              {unit}
            </Typography>
          </div>
        ))}
      </Box>
    );
  }, []);

  return (
    <Box className="meal-summary" sx={{ ...style }}>
      {meal?.title && (
        <Typography className="meal-summary__title" variant="body1">
          {meal.title}
        </Typography>
      )}

      {hasValidMacros && renderMacroMetrics(validMacros)}
      {!hasValidMacros && hasValidSummaryMacro && (
        <div className="meal-summary__day-summary">
          <Typography className="meal-summary__title" variant="body1">
            Day Summary
          </Typography>
          {renderMacroMetrics(validSummaryMacro)}
        </div>
      )}

      {meal?.source && (
        <Typography className="meal-summary__source" variant="subtitle2">
          Data source: {meal.source}
        </Typography>
      )}
    </Box>
  );
};

export default MealSummary;
